export default __webpack_public_path__ + "static/B46-f7a223e439f1f28d820aa22ab05b4bf6.png";